<template>
    <div>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="资源名称" prop='name'>
                    <el-input v-model="searchForm.name" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="资源" prop='zy'>
                    <el-input v-model="searchForm.zy" placeholder=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add()">新增</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            :tree-props="{children: 'list'}"
        >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="name" label="资源名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="zy" label="资源"  width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="lj" label="真实路径"  min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bz" label="备注" min-width="170" show-overflow-tooltip>
            </el-table-column>
            <el-table-column  label="操作" width="180" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                    <el-button type="text"  @click='add(scope.row)' v-if='scope.row.list'>新增子项</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增编辑 -->
        <el-dialog :title='isEdit?"编辑资源":"新增资源"' :visible.sync="dialogVisible" width='700px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="80px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称" prop='name'>
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="资源" prop='zy'>
                            <el-input v-model="form.zy"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="实际路径" prop='lj'>
                            <el-input v-model="form.lj"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排序号" prop='num'>
                            <el-input v-model="form.num"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="备注" prop='bz'>
                    <el-input v-model="form.bz"></el-input>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'',
    components:{
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                name:'',
                zy:''
            },
            tableData:[],
            dialogVisible:false,
            isEdit:false,
            form:{
                name:'',
                zy:'',
                lj:'',
                num:'',
                bz:''
            },
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.lx=this.adminLx
            this.$api.getZygl(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data
                }
            }).catch(()=>{})
        },
        search(){
            this.getData();
        },
        //新增
        add(obj){
            this.form={
                name:'',
                zy:'',
                lj:'',
                num:'',
                bz:'',
                lx:this.adminLx
            }
            this.dialogVisible=true;
            this.isEdit=false;
            if(obj){
               this.form.parentId=obj.id 
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.isEdit=true;
            this.form=Object.assign({},row);
            this.form.lx=this.adminLx
        },
        saveForm(formName){
            this.$refs[formName].validate((valid)=>{
                if(valid){
                    let para=this.form
                    this.$api.saveZygl(para).then(res=>{
                        if(res.data.meta.success){
                            this.$message({
                                type:'success',
                                message:'保存成功！'
                            })
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message({
                                type:'error',
                                message:res.data.meta.message
                            })
                        }
                    }).catch(()=>{})
                }else{
                    return false;
                }
            })
           
        },
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false;
        },
        //删除
        del(row){
            let para={
                id:row.id,
                lx:this.adminLx
            }
            this.$confirm('确定要删除当前的资源吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delZygl(para).then(res=>{
                    if(res.data.meta.success){

                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });
        },
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>